import { Pipe, PipeTransform } from '@angular/core';
import { Options } from 'humanize-duration';
import * as humanizer from 'humanize-duration';

@Pipe({
    name: 'humanizeDate',
    standalone: false
})
export class HumanizeDatePipe implements PipeTransform {

  transform(value: number | null | undefined, config: Options): string | undefined {
    if (!value) return undefined
    return humanizer(value!, config)
  }

}
